import React,{useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { MDBDataTable } from "mdbreact";
import { usersUrl } from "../../Url";
import { mailUrl } from "../../Url";
import { useReactToPrint } from 'react-to-print';
import {html2pdf} from 'html2pdf.js'

const Datatable = () => {
  const navigate = useNavigate();
  const storedToken = window.localStorage.getItem("token");
  const [load, setLoad] = useState(false);

  const handleDetailClick = (email) => {
    navigate(`/details-demande/${email}`);
  };

  const [users, setUsers] = useState([]);
  const tableRef = React.createRef();
  const [print, setPrint] = useState(false);

  const user = JSON.parse(window?.localStorage.getItem("userData")?? "{}");
  useEffect(()=>{

    if(!user || !user?.id){
      navigate('/login')
    }
    if(user && user.roles == "CLIENT"){
      navigate('/')
    }
  }, [users])

  useEffect(()=>{
    axios
        .get(usersUrl, {
          headers: {
            Authorization: `Bearer ${storedToken}`
          }
        })
        .then((response) => {
          console.log(response);
          setUsers(response.data.data)
        })
        .catch((err) => {
          console.log(err);
        });
  },[])

  function formatDate(dateActuelle) {
    
    const jour = dateActuelle.getDate();
    const mois = dateActuelle.getMonth() + 1; // Les mois sont 0-indexés, donc on ajoute 1
    const annee = dateActuelle.getFullYear();
    const heures = dateActuelle.getHours();
    const minutes = dateActuelle.getMinutes();
    const secondes = dateActuelle.getSeconds();

    return `${jour}-${mois}-${annee} à ${heures}:${minutes}:${secondes}`;
  }

  function roleUser(role){

    return role === "CLIENT" ? "Superviseur" : "SuperAdmin";
  }

  const handlePrint = useReactToPrint({
    content: () => tableRef.current,
    documentTitle: `statistiques-générées-par-${user?.firstname}_${user?.firstname}-le-${formatDate(new Date())}`.toLowerCase(),
    onBeforePrint: () => {
      /*setPrint(true)*/
    },
    onBeforeGetContent: () => {
      /*setPrint(true)*/
    },
    onPrintError: () => {
      /*setPrint(true)*/
    },
    onAfterPrint: () => {
      console.log('Statistique générées avec succès!')
      /*setPrint(false)*/
    },
  });

  function handlePrint1(){
    setPrint(true);
  }

  function handlePrint3(){
    setPrint(false);
  }

  function handlePrint2(){
    handlePrint();
  }

  const handleShare = useReactToPrint({
    content: () => tableRef.current,
    documentTitle: `test.pdf`,
    copyStyles: true,
    print: async (printIframe) => {
      const document = printIframe.contentDocument;
      if (document) {
        const html = document.getElementsByTagName('html')[0];
        console.log(html);
        await html2pdf().from(html).save();
      }
    }
  });

  const datas = {
    columns: [
      /*{
        label: "Numero",
        field: "id",
        sort: "asc",
        width: 30,
      },*/
      {
        label: "Nom",
        field: "firstname",
        sort: "asc",
        width: 150,
      },
      {
        label: "Prenom",
        field: "lastname",
        sort: "asc",
        width: 270,
      },
      {
        label: "Email",
        field: "email",
        sort: "asc",
        width: 200,
      },
      {
        label: "Activité",
        field: "activite",
        sort: "asc",
        width: 150,
      },
      {
        label: "Profil",
        field: "category",
        sort: "asc",
        width: 100,
      },
      {
        label: "Actions",
        field: "actions",
        width: 100,
      },
    ],
    rows: [
      // {
      //   firstname: "Sesame",
      //   lastname: "Admin",
      //   email: "admin@gmail.com",
      //   id: "01",
      //   type: "Information",
      //   category: "PME",
      // },
      // {
      //   firstname: "Sesame",
      //   lastname: "Root",
      //   email: "root@gmail.com",
      //   id: "02",
      //   type: "Formation",
      //   category: "Startup",
      // }
    ],
  };

  const [data, setData] = useState(datas);

  function types(type){
    if(type=="Formalisation"){
      return "Accompagnement"
    }
    if(type=="Formation"){
      return "Garantie"
    }
    else{
      return type
    }
  }

  function categoryF(category){

    return category =="PME"? "PME / Startup" : category =="Startup"? "Groupement": category
  }

  useEffect(()=>{
    if(users?.length > 0){
      
      const newData = [];
      for (const user of users) {
        newData.push({
          firstname: user.firstname,
          lastname: user.lastname,
          email: user.email,
          activite: user.activite,
          id: user.id,
          // type: types(user.type),
          category: categoryF(user.category)
        })
      }

      setData({columns: data.columns, rows: newData})
    }
  },[users])

  const rows = data.rows.map((rowData, index) => {
    return {
      ...rowData,
      actions: (
        <button
          className="btn-details px-3 py-1 shadow d-flex justify-content-center"
          onClick={() => handleDetailClick(rowData.email)}
        >
          N {rowData.id}
        </button>
      ),
      id: index,
    };
  });

  return (
    <div>
      {
        print ? 
        (
          <div style={{display:"flex", justifyContent: "start"}}>
          <button className="btn-details px-3 py-1 shadow d-flex justify-content-center" onClick={handlePrint}>Valider l'impression</button>
          <button className="btn-details px-3 py-1 shadow d-flex justify-content-center" onClick={()=>handlePrint3()}>Annuler l'impression</button>
          </div>
        )
        :
        (
          <button className="btn-details px-3 py-1 shadow d-flex justify-content-center" onClick={()=>handlePrint()}>Télécharger</button>
        )
      }
      {!print && (
        <div ref={tableRef} className="mr-3 ml-2">
          <MDBDataTable striped bordered small data={{ ...data, rows }} />
        </div>
      )}
      {print && (
        <MDBDataTable striped bordered small data={data} />
      )}
    </div>
  )
};

export default Datatable;
